import { render, staticRenderFns } from "./file-history.vue?vue&type=template&id=9932a9b8&scoped=true"
import script from "./file-history.vue?vue&type=script&lang=js"
export * from "./file-history.vue?vue&type=script&lang=js"
import style0 from "./file-history.vue?vue&type=style&index=0&id=9932a9b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9932a9b8",
  null
  
)

export default component.exports